import { __makeTemplateObject } from 'tslib';
import { css } from 'styled-components';
import { baseStyles } from '../BaseLink/BaseLink.baseStyles.js';
import { buildSpacingCSS } from '../../theme/utils/spacing.js';

var ExternalLinkStyles = function ExternalLinkStyles(theme, globalMargins, propMargins) {
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  & .fi-link_icon {\n    margin: 0;\n    padding-left: ", ";\n    font-size: 16px;\n    box-sizing: content-box;\n  }\n"], ["\n  ", "\n  ", "\n  ", "\n  & .fi-link_icon {\n    margin: 0;\n    padding-left: ", ";\n    font-size: 16px;\n    box-sizing: content-box;\n  }\n"])), baseStyles(theme), buildSpacingCSS(globalMargins), buildSpacingCSS(propMargins, true), theme.spacing.insetXs);
};
var templateObject_1;

export { ExternalLinkStyles };
//# sourceMappingURL=ExternalLink.baseStyles.js.map
